export enum DrawingTypes {
  THREE_D,
  TECHNICAL
}